module.exports = __webpack_public_path__ + "static/media/modelez.d069a345.png";